module.exports = __webpack_public_path__ + "img/karton-opreme.3e33ee53.svg";